<div class="model savedrawer">
    <div class="model-body">
        <div class="header box-header">

        </div>
        <div class="model-content">
            <div class="condition-container">
                <div class="condition">
                    You're about to replace the existing data with the data from your file. Are you sure you
                    want to import?
                </div>

                <div class="button-container">
                    <button type='button' class="btn btn-success confirm-btn"
                        (click)="importBusinessComponent()">Import</button> &nbsp;
                    <button class="btn kpmg-button--flat" (click)="closeDialog()">Go back</button>
                </div>
            </div>
        </div>
    </div>
</div>